import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { IProcedure, IAction } from '../../../redux/timeline-data.model';
import { bbGenerateShortId } from '../../../../../../shared/utils/bbGenerateShortId.util';
import { InteractivityActionService } from '../../../services/interactivity-action.service';
export interface ProcedureItem {
	label: string;
	htmlLabel?: string;
	icon?: string;
	value?: string;
	action?: IAction;
}
@Component({
	selector: 'add-procedure',
	templateUrl: './add-procedure.component.html',
	styleUrls: ['./add-procedure.component.scss']
})
export class AddProcedureComponent implements OnInit {
	@Input() allowIfElse?: boolean = false;
	@Input() theme?: string;
	@Input() propertyKey?: string;
	@Input() procedures?: IProcedure[];
	@Input() actions?: IAction[];
	@Output() onChange: EventEmitter<any> = new EventEmitter<any>();
	addableProcedures = [{
		label: 'navigate',
		htmlLabel: `<strong>navigate</strong> to`,
		icon: 'compass',
		value: 'navigate',
		action: {
			entity: 'player',
			command: 'load',
			parameters: [{
				name: 'p_0',
				value: ''
			},
			{
				name: 'p_1',
				value: ''
			}]
		}
	},
	{
		label: 'player',
		htmlLabel: `control <strong>player</strong>`,
		icon: 'play-circle-o',
		value: 'player',
		action: {
			entity: 'player',
			command: 'pause',
			parameters: []
		}
	},
	{
		label: 'widget property/method',
		htmlLabel: `change <strong>widget</strong>`,
		icon: 'crosshairs',
		value: 'widget',
		action: {
			entity: 'widget',
			command: 'callMethod',
			parameters: [{
				name: 'p_0',
				value: ''
			},
			{
				name: 'p_1',
				value: ''
			},
			{
				name: 'p_2',
				value: ''
			}]
		}
	},
	{
		label: 'local storage',
		htmlLabel: `set <strong>local storage</strong>`,
		icon: 'server',
		value: 'localstorage',
		action: {
			entity: 'localstorage',
			command: 'setItem',
			parameters: [{
				name: 'p_0',
				value: ''
			},
			{
				name: 'p_1',
				value: ''
			}]
		}
	},
	{
		label: 'script',
		htmlLabel: `run <strong>script</strong>`,
		icon: 'code',
		value: 'script',
		action: {
			entity: 'javascript',
			command: '',
			parameters: [{
				name: 'p_0',
				value: ''
			}]
		}
	},
	{
		label: 'send',
		htmlLabel: `send <strong>item</strong>`,
		icon: 'paper-plane',
		value: 'send',
		action: {
			entity: 'message',
			command: '',
			parameters: []
		}
	}];

	extraAddableProcedures: any[] = null;
	currentMouseOverItem: any = null;
	initialized = false;

	constructor(
		private actionService: InteractivityActionService) {

	}

	ngOnInit() {
		this.init();
	}

	init() {
		if (this.allowIfElse) {
			this.extraAddableProcedures = [{
				label: 'if-then',
				htmlLabel: `add <strong>if-then</strong>`,
				svgIcon: '/resources/img/interactivity/if-then.svg',
				value: 'if-then'
			}];
		}
		this.initialized = true;
	}

	closeButtonBar() {
		this.currentMouseOverItem = null;
	}

	mouseOverItem(ev: any) {
		this.currentMouseOverItem = this.addableProcedures.find((item: any) => item.value === ev.value) ||
			this.extraAddableProcedures.find((item: any) => item.value === ev.value) || {};
	}

	mouseLeaveItem(ev: any) {
		this.currentMouseOverItem = null;
	}

	itemSelected(item: any) {
		this.currentMouseOverItem = null;
		this.addProcedure(item);
	}

	addProcedure(item: any): void {
		const newAction: IAction = item.action ? {...item.action} : {
			entity: item.value,
			command: '',
			parameters: []
		};

		newAction.id = bbGenerateShortId();

		if (this.procedures) {
			const procedure: IProcedure = {
				id: bbGenerateShortId(),
				condition: {
					variables: [],
					expression: ''
				},
				actions: item.value === 'if-then' ? [] : [newAction],
				else_actions: [],
				type: item.value === 'if-then' ? 'conditional' : 'simple'
			};

			this.procedures.push(procedure);
			const msg = `Added ${item.value} action to ${this.propertyKey}`;
			this.onChange.emit(msg);
		} else if (this.actions) {
			this.actions.push(newAction);
			const msg = `Added ${newAction.entity} action`;
			this.onChange.emit(msg);
		}

		this.actionService.deselectAllActions();
		this.actionService.selectAction(newAction.id);
	}
}
